<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="page">
    <!-- 顶部栏 -->
    <header class="header">
      <div class="header-left">
        <div class="back" @click="goBack">
          <img src="@/assets/report/back.png" alt="" />
        </div>
      </div>
      <div class="header-right">
        <div class="help-btn" @click="helpModalVisible = true">
          <span>说明</span>
        </div>
      </div>
    </header>

    <!-- 主内容区 -->
    <main class="content">
      <div class="title"></div>
      <div class="intro">
        为了给您推荐最合适的起点和学习内容，我们邀请您先进行一个轻松的单词量小测评
      </div>

      <!-- 级别选择卡片 -->
      <div class="level-cards">
        <template v-if="isStageLoading">
          <div
            v-for="n in 4"
            :key="`skeleton-${n}`"
            class="level-card level-card-skeleton"
          >
            <div class="skeleton-line"></div>
          </div>
        </template>
        <template v-else>
          <div
            v-for="item in levels"
            :key="item.value"
            class="level-card"
            :class="{ active: selectedLevel === item.value }"
            @click="selectedLevel = item.value"
          >
            {{ item.label }}
          </div>
        </template>
      </div>

      <div class="up"></div>
      <p class="level-tip">请选择你认为你的英语词汇量水平</p>

      <!-- 操作按钮 -->
      <div class="start-btn" @click="goReport">立即开始</div>
      <div class="skip-link" @click="skipModalVisible = true">跳过初次测评</div>
    </main>

    <ModalPopup
      :visible="helpModalVisible"
      width="710px"
      height="auto"
      :border-radius="50"
      padding="15px 25px 25px"
      @close="helpModalVisible = false"
    >
      <div class="help-modal-content">
        <div class="help-modal-title-wrap">
          <div class="help-modal-title">首次测评说明介绍</div>
        </div>

        <div class="help-modal-scroll-wrap">
          <div class="help-modal-intro">
            欢迎来到AI英语学伴，在正式开始前，推荐您进行 “首次测评”！
            首次测评将会估算您的词汇量，以及精准定位您的优势与薄弱环节，为您提供一份真正个性化的“词汇能力体检报告”，为您后续的学习提供标准参考和意见。
          </div>
          <div class="help-modal-section">
            <div class="help-modal-h">一、如何开始?</div>
            <div class="help-modal-body">
              <div>
                (1)
                选择学段（可选）：为给您更合适的起始难度，请选择您对应的学习阶段（如“小学”、“初中”、“高中”）。如果您不确定，可直接选择由系统判断。
              </div>
              <div>
                (2) 阅读引导：点击 【开始测评】 前，请花几秒钟阅读测评说明。
              </div>
              <div>(3) 开始测试：准备好后，点击按钮，测试即刻开始！</div>
            </div>
          </div>
          <div class="help-modal-section">
            <div class="help-modal-h">二、答题界面与操作</div>
            <div class="help-modal-body">
              <div>题目形式：您将看到一个英文单词和四个中文释义选项。</div>
              <div>(1) 如果您认识该词，请选择您认为最准确的中文释义。</div>
              <div>
                (2) 如果您完全不认识这个词，请直接点击最下方的 【不认识】 按钮。
              </div>
              <div>
                温馨提示：请根据第一印象作答，无需长时间思考。诚实地选择“不认识”会让结果更精准！
              </div>
            </div>
          </div>
          <div class="help-modal-section">
            <div class="help-modal-h">三、测试报告</div>
            <div class="help-modal-body">
              <div class="help-modal-body-dark">
                测评完成后，您将获得一份详细的 《词汇量测评报告》，它包含：
              </div>
              <div>
                词汇量估算：您的预估词汇量值 
              </div>
              <div>级别定位：您的水平对应的标准学段（例如：小学高阶 ）。</div>
              <div>
                能力雷达图：直观展示您在
                6大主题领域（日常生活、学校学习、自然科学、社会文化、学术抽象、专业领域）的掌握情况，一眼看清优势与短板。
              </div>
              <div>学习建议：根据您的薄弱环节，生成可执行的个性化学习计划。</div>
            </div>
            <div class="help-modal-section">
              <div class="help-modal-h">四、注意事项</div>
              <div class="help-modal-body">
                <div>
                  环境：请在网络通畅、安静的环境下进行测试，以确保体验。
                </div>
                <div>
                  诚信：为了得到最真实的结果，请独立完成，不要查阅词典或求助他人。测试结果仅为您个人参考，无需有压力。
                </div>
                <div>时间：单次测试时长约 5-15分钟。</div>
              </div>
            </div>
          </div>
          <div class="help-modal-action">
            现在就开始您的首次词汇量测评之旅吧!
          </div>
          <div class="help-modal-note">
            <span class="help-modal-note-icon">!</span>
            提示：您可选择跳过本次测评，后续在 【精准测评】 模块重新进行。
          </div>
        </div>
        <div class="help-modal-btn" @click="helpModalVisible = false">
          好 的
        </div>
      </div>
    </ModalPopup>

    <ModalPopup
      :visible="skipModalVisible"
      width="372px"
      height="auto"
      :border-radius="30"
      @close="skipModalVisible = false"
      padding="44px 45px 20px"
    >
      <div class="skip-modal-content">
        <p class="skip-modal-text">
          已为您跳过首次测评，后续您可以在<span class="highlight"
            >【精准测评】</span
          >进行词汇量测评哦!
        </p>
        <div class="skip-modal-btn" @click="goBack">
          好 的
        </div>
      </div>
    </ModalPopup>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue";
import { useRouter } from "vue-router";
import ModalPopup from "@/components/ModalPopup.vue";
import { setDesignSize } from "@/utils/adapt.js";
import { getToken, setToken } from "@/utils/auth.js";
import { selectStageList, initPreciseExam } from "@/api/precise.js";
import { authLogin } from "@/api/userAuth.js";

const router = useRouter();

onMounted(async () => {
  setDesignSize(960, 600);
  if (!getToken()) {
    try {
      const res = await authLogin({
        nickname: "胡梓源",
        userId: "418094",
        type: "FZD",
      });
      const tk = res?.data?.token;
      if (tk) {
        setToken(tk);
      }
    } catch (error) {
      console.error("登录认证失败:", error);
    }
  }
  loadStageList();
});

onBeforeUnmount(() => {
  window.dispatchEvent(new Event("resize"));
});
const skipModalVisible = ref(false);
const helpModalVisible = ref(false);

// 阶段列表：仅由接口返回渲染，不使用本地假数据
const levels = ref([]);
const selectedLevel = ref(null);
const isStarting = ref(false);
const isStageLoading = ref(true);

async function loadStageList() {
  isStageLoading.value = true;
  try {
    const res = await selectStageList();
    const list = Array.isArray(res?.data) ? res.data : [];
    if (list.length === 0) {
      levels.value = [];
      selectedLevel.value = null;
      return;
    }
    levels.value = list.map((item) => ({
      label: item.stageName,
      value: item.stageType,
    }));
    selectedLevel.value = levels.value[0]?.value ?? null;
  } catch (error) {
    console.error("查询学段失败:", error);
  } finally {
    isStageLoading.value = false;
  }
}

function goBack() {
  const quitRequest = JSON.stringify({
    func: "quit",
  });
  if (window.android) {
    window.android.callNative(quitRequest);
  } else {
    window.history.back();
  }
}

async function goReport() {
  if (isStarting.value) return;
  if (!selectedLevel.value) return;
  isStarting.value = true;
  try {
    const res = await initPreciseExam(selectedLevel.value);
    // 供答题页使用初始化结果
    if (res?.data) {
      localStorage.setItem("preciseExamInit", JSON.stringify(res.data));
    }
    router.push("/firstExam/exam");
  } catch (error) {
    console.error("初始化测评失败:", error);
  } finally {
    isStarting.value = false;
  }
}
</script>

<style scoped lang="scss" src="./index.scss"></style>
